<template>
  <login-layout :title="$t('Verifica dell\'indirizzo in corso')">
    <pf-spinner v-if="loading" />
    <template v-else>{{ message }}</template>
  </login-layout>
</template>

<script lang="ts" setup>
import { pop } from '@common/utils';
import LoginLayout from '../../components/login-layout.vue';
import { Resource } from '@/resources';
import axios from 'axios';
import { $t } from '@/i18n';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

defineOptions({
  name: 'UnsubscribePage',
});

const route = useRoute();
const loading = ref(true);
const message = ref('');

onMounted(async() => {
  const email = pop(route.params.mail);

  try{
    if (!email) {
      return;
    }
    await unsubscribe(email);
    message.value = $t("L'indirizzo {0} è stato disiscritto correttamente dalla newsletter", [email]);
  } catch (e: any) {
    if (!axios.isAxiosError(e) || e.response?.status !== 404) {
      throw e;
    }
    message.value = $t("L'indirizzo {0} non è stato trovato", [email]);
  } finally {
    loading.value = false;
  }
});

async function unsubscribe(email: string) {
  await new Resource('newsletter_subscription').delete(email);
}
</script>
